
const steps = [
  {
    number: "01",
    title: "Create Your Profile",
    description: "Sign up and showcase your skills, experience, and examples of your work."
  },
  {
    number: "02",
    title: "Offer Your Services",
    description: "List the services you can provide, set your rates, and define your availability."
  },
  {
    number: "03",
    title: "Get Discovered",
    description: "Clients browse the platform and find your services based on their needs."
  },
  {
    number: "04",
    title: "Complete Projects",
    description: "Deliver quality work, receive payment, and build your reputation with reviews."
  }
];

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-16 md:py-24 bg-gradient-to-b from-muted/50 to-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="font-poppins font-bold text-3xl md:text-4xl mb-4 text-foreground">How AnySkill Works</h2>
          <p className="font-inter text-muted-foreground max-w-2xl mx-auto">
            Our simple process helps students start offering their services quickly and safely.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-card rounded-xl p-8 shadow-md h-full">
                <span className="font-poppins font-bold text-5xl text-anyskill-purple/70">{step.number}</span>
                <h3 className="font-poppins font-semibold text-xl mt-4 mb-3 text-card-foreground">{step.title}</h3>
                <p className="font-inter text-muted-foreground">{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 right-0 transform translate-x-1/2 -translate-y-1/2">
                  <div className="w-8 h-0.5 bg-anyskill-purple"></div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
